import countriesData from "../data/countries.json";

export const countriesList = countriesData;

export async function refreshCountriesList() {
  return countriesList;
}
